import { render, staticRenderFns } from "./form.vue?vue&type=template&id=7c29ff47&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c29ff47')) {
      api.createRecord('7c29ff47', component.options)
    } else {
      api.reload('7c29ff47', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=7c29ff47&", function () {
      api.rerender('7c29ff47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/category/form.vue"
export default component.exports